import { render } from "./PeoplePieChartNum.vue?vue&type=template&id=49aaec0e&scoped=true"
import script from "./PeoplePieChartNum.vue?vue&type=script&lang=js"
export * from "./PeoplePieChartNum.vue?vue&type=script&lang=js"

import "./PeoplePieChartNum.vue?vue&type=style&index=0&id=49aaec0e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49aaec0e"]])

export default __exports__